import { useQuery } from "@tanstack/react-query";
import { LengthBundleRow } from "../models/LengthBundleRow";
import { getLengthBundles } from "../repositories/lengthReportRepository";

type UseLengthBundlesProps = {
	startDate: Date;
	endDate: Date;
	productCode?: number | null;
	onError: (error: Error) => void;
};

export const useLengthBundles = ({
	startDate,
	endDate,
	productCode,
	onError,
}: UseLengthBundlesProps) => {
	return useQuery<LengthBundleRow[], Error>({
		queryKey: ["lengthBundles", startDate, endDate, productCode],
		queryFn: () =>
			getLengthBundles({
				start: startDate,
				end: endDate,
				productCode,
			}),
		onError,
	});
};
